import { Routes } from '@angular/router';
import { AuthGuard } from './features/auth/guards/auth.guard';

import { academicYearResolver, schoolLevelReferenceResolver } from './shared/resolvers/common.resolvers';
import { accessRuleGuard } from './shared/guards/common.guards';
import { Permission, Role } from './shared/services/permissions.service';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
  },
  {
    path: 'auth',
    loadComponent: () => import('./features/auth/pages/auth/auth').then((m) => m.Auth),
  },
  {
    path: 'reset-password',
    canActivate: [AuthGuard],
    loadComponent: () => import('./features/auth/pages/reset-password/reset-password').then((m) => m.ResetPassword),
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadComponent: () => import('./shared/components/app-layout/app-layout').then((m) => m.AppLayout),
  },
  {
    path: 'school-selection',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/auth/pages/school-selection/school-selection').then((m) => m.SchoolSelection),
  },
  {
    path: 'not-allowed',
    loadComponent: () => import('./shared/commons/ui/not-allowed/not-allowed').then((m) => m.NotAllowed),
  },
  {
    path: 'not-found',
    loadComponent: () => import('./shared/commons/ui/not-found/not-found').then((m) => m.NotFound),
  },
  {
    path: 'schools',
    canActivate: [AuthGuard],
    loadComponent: () => import('./shared/components/app-layout/app-layout').then((m) => m.AppLayout),
    children: [
      {
        path: ':schoolPublicId/setup',
        loadComponent: () => import('./features/admin/schools/school-setup/school-setup').then((m) => m.SchoolSetup),
      },
      {
        path: ':schoolPublicId/fees',
        loadComponent: () => import('./features/admin/schools/price-setup/price-setup').then((m) => m.PriceSetup),
      },
    ],
  },
  {
    path: 'admins',
    canActivate: [AuthGuard, accessRuleGuard],
    data: {
      roles: [Role.SAAS_ADMIN],
    },
    loadComponent: () => import('./shared/components/app-layout/app-layout').then((m) => m.AppLayout),
    children: [
      {
        path: '',
        redirectTo: 'schools',
        pathMatch: 'full',
      },
      {
        path: 'schools',
        loadChildren: () => import('./features/admin/schools/schools.routes').then((m) => m.SCHOOL_ROUTES),
      },
    ],
  },
  {
    path: 'students',
    canActivate: [AuthGuard],
    loadComponent: () => import('./shared/components/app-layout/app-layout').then((m) => m.AppLayout),
    children: [
      {
        path: '',
        redirectTo: 'registration',
        pathMatch: 'full',
      },
      {
        path: 'registration',
        canActivate: [accessRuleGuard],
        data: {
          permissions: [Permission.MANAGE_ENROLLMENT],
        },
        resolve: {
          levels: schoolLevelReferenceResolver,
          academicYears: academicYearResolver,
        },
        loadChildren: () => import('./features/student/student.routes').then((m) => m.STUDENT_ROUTES),
      },
    ],
  },

  {
    path: '**',
    loadComponent: () => import('./shared/commons/ui/not-found/not-found').then((m) => m.NotFound),
  },
];
